import { useEffect } from 'react';
import Header from 'components/Header';
import SEO from 'components/SEO';
import VisitorTracker from 'components/VisitorTracker';
import AdSense from 'components/AdSense';
import { ADSENSE_SLOTS } from 'config/adsense.config';
import { Outlet, useLocation } from 'react-router-dom';
import { RootContainer } from './styles';
import Footer from 'components/Footer';
import { ToastContainer } from 'react-toastify';

const CONTENT_AD_PATHS = ['/guide', '/faq'];

const RootLayout = () => {
  const { pathname } = useLocation();
  const showFooterAd = CONTENT_AD_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <SEO />
      <VisitorTracker />
      <Header />

      <RootContainer>
        <Outlet />
      </RootContainer>

      {/* 콘텐츠가 충분한 가이드·FAQ에만 푸터 광고 노출 (빈약 콘텐츠 정책 대응) */}
      {showFooterAd && <AdSense slot={ADSENSE_SLOTS.banner} />}

      <Footer />

      <ToastContainer theme='light' toastStyle={{ fontFamily: 'inherit' }} />
    </>
  );
};

export default RootLayout;
